import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { isNil, isEmpty, pathOr } from 'ramda';

const type = (state = null, action) => {
  return pathOr(null, ['payload', 'notie', 'type'], action);
};

const message = (state = null, action) => {
  return pathOr(null, ['payload', 'notie', 'message'], action);
};

const notie = combineReducers({
  type,
  message,
});

export default notie;

export const messageSelector = state => state.notie.message;
export const typeSelector = state => state.notie.type;

export const shouldShowNotieSelector = createSelector(
  messageSelector,
  message => !isNil(message) && !isEmpty(message)
);
